export default function FormButton({
  text,
  icon,
  isLoading,
  loadingText,
  ...rest
}) {
  return (
    <button
      className="auth__submit-button"
      type="submit"
      disabled={isLoading}
      {...rest}
    >
      {isLoading ? (
        loadingText
      ) : (
        <>
          {text}
          {icon}
        </>
      )}
    </button>
  );
}
